'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require('react-motion');

var _Events = require('./Events');

var _Events2 = _interopRequireDefault(_Events);

var _EventLine = require('./EventLine');

var _EventLine2 = _interopRequireDefault(_EventLine);

var _Faders = require('./Faders');

var _Faders2 = _interopRequireDefault(_Faders);

var _HorizontalTimelineButtons = require('./HorizontalTimelineButtons');

var _HorizontalTimelineButtons2 = _interopRequireDefault(_HorizontalTimelineButtons);

var _Constants = require('../Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventsBar = function (_React$Component) {
  _inherits(EventsBar, _React$Component);

  function EventsBar(props) {
    _classCallCheck(this, EventsBar);

    var _this = _possibleConstructorReturn(this, (EventsBar.__proto__ || Object.getPrototypeOf(EventsBar)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      position: 0,
      maxPosition: Math.min(props.visibleWidth - props.totalWidth, 0)
    };

    _this.touch = {
      coors: {
        x: 0,
        y: 0
      },
      isSwiping: false,
      started: false,
      threshold: 3
    };
    return _this;
  }

  _createClass(EventsBar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.body.addEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selectedEvent = this.props.events[this.props.index];
      this.slideToPosition(-(selectedEvent.distance - this.props.visibleWidth / 2), this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var selectedEvent = props.events[props.index];
      var minVisible = -this.state.position; // Position is always negative!
      var maxVisible = minVisible + props.visibleWidth;

      if (selectedEvent.distance > minVisible + 10 && selectedEvent.distance < maxVisible - 10) {
        //Make sure we are not outside the view
        this.slideToPosition(this.state.position, props);
      } else {
        //Try to center the selected index
        this.slideToPosition(-(selectedEvent.distance - props.visibleWidth / 2), props);
      }
    }

    /**
     * Slide the timeline to a specific position. This method wil automatically cap at 0 and the maximum possible position
     * @param {number} position: The position you want to slide to
     * @return {undefined} Modifies the value by which we translate the events bar
     */


    /**
     * This method translates the timeline by a certaing amount depending on if the direction passed
     * is left or right.
     *
     * @param {string} direction The direction towards which the timeline will translates
     * @param {object} the props to use during this calcuation
     * @return {undefined} Just modifies the value by which we need to translate the events bar in place
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      //  creating an array of list items that have an onClick handler into which
      //  passing the index of the clicked entity.
      // NOTE: Improve timeline dates handeling and eventsMinLapse handling
      var touchEvents = this.props.isTouchEnabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd
      } : {};

      // filled value = distane from origin to the selected event
      var filledValue = this.props.events[this.props.todayIndex].distance - this.props.barPaddingLeft;
      var eventLineWidth = this.props.totalWidth - this.props.barPaddingLeft - this.props.barPaddingRight;

      return _react2.default.createElement(
        'div',
        _extends({
          style: {
            width: this.props.width + 'px',
            height: this.props.height + 'px'
          }
        }, touchEvents),
        _react2.default.createElement(
          'div',
          {
            className: 'events-wrapper',
            style: {
              position: 'relative',
              height: '100%',
              margin: '0 40px',
              overflow: 'hidden'
            }
          },
          _react2.default.createElement(
            _reactMotion.Motion,
            {
              style: {
                X: (0, _reactMotion.spring)(this.state.position, this.slidingMotion)
              }
            },
            function (_ref) {
              var X = _ref.X;
              return _react2.default.createElement(
                'div',
                {
                  className: 'events',
                  style: {
                    position: 'absolute',
                    left: 0,
                    top: 80,
                    height: 3,
                    width: _this2.props.totalWidth,
                    WebkitTransform: 'translate3d(' + X + ', 0, 0)px',
                    transform: 'translate3d(' + X + 'px, 0, 0)'
                  }
                },
                _react2.default.createElement(_EventLine2.default, {
                  left: _this2.props.barPaddingLeft,
                  width: eventLineWidth,
                  fillingMotion: _this2.props.fillingMotion,
                  backgroundColor: _this2.props.styles.outline
                }),
                _react2.default.createElement(_EventLine2.default, {
                  left: _this2.props.barPaddingLeft,
                  width: filledValue,
                  fillingMotion: _this2.props.fillingMotion,
                  backgroundColor: _this2.props.styles.foreground
                }),
                _react2.default.createElement(_Events2.default, {
                  events: _this2.props.events,
                  selectedIndex: _this2.props.index,
                  styles: _this2.props.styles,
                  handleDateClick: _this2.props.indexClick,
                  labelWidth: _this2.props.labelWidth
                })
              );
            }
          )
        ),
        _react2.default.createElement(_Faders2.default, { styles: this.props.styles }),
        _react2.default.createElement(_HorizontalTimelineButtons2.default, {
          maxPosition: this.state.maxPosition,
          position: this.state.position,
          styles: this.props.styles,
          updateSlide: this.updateSlide
        })
      );
    }
  }]);

  return EventsBar;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleKeydown = function (event) {
    if (_this3.props.isKeyboardEnabled) {
      if (event.keyCode === _Constants2.default.LEFT_KEY || event.keyCode === _Constants2.default.RIGHT_KEY) {
        _this3.updateSlide(_Constants2.default.KEYMAP[event.keyCode]);
      } else if (event.keyCode === _Constants2.default.UP_KEY) {
        _this3.props.indexClick(Math.min(_this3.props.selectedIndex + 1, _this3.props.events.length - 1));
      } else if (event.keyCode === _Constants2.default.DOWN_KEY) {
        _this3.props.indexClick(Math.max(_this3.props.selectedIndex - 1, 0));
      }
    }
  };

  this.handleTouchStart = function (event) {
    var touchObj = event.touches[0];

    _this3.touch.coors.x = touchObj.pageX;
    _this3.touch.coors.y = touchObj.pageY;
    _this3.touch.isSwiping = false;
    _this3.touch.started = true;
  };

  this.handleTouchMove = function (event) {
    if (!_this3.touch.started) {
      _this3.handleTouchStart(event);
      return;
    }

    var touchObj = event.touches[0];
    var dx = Math.abs(_this3.touch.coors.x - touchObj.pageX);
    var dy = Math.abs(_this3.touch.coors.y - touchObj.pageY);

    var isSwiping = dx > dy && dx > _this3.touch.threshold;

    if (isSwiping === true || dx > _this3.touch.threshold || dy > _this3.touch.threshold) {
      _this3.touch.isSwiping = isSwiping;
      var dX = _this3.touch.coors.x - touchObj.pageX; // amount scrolled
      _this3.touch.coors.x = touchObj.pageX;
      _this3.setState({
        position: _this3.state.position - dX // set new position
      });
    }
    if (_this3.touch.isSwiping !== true) {
      return;
    }
    // Prevent native scrolling
    event.preventDefault();
  };

  this.handleTouchEnd = function (event) {
    // Make sure we are scrolled to a valid position
    _this3.slideToPosition(_this3.state.position);
    _this3.touch.coors.x = 0;
    _this3.touch.coors.y = 0;
    _this3.touch.isSwiping = false;
    _this3.touch.started = false;
  };

  this.slideToPosition = function (position) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this3.props;

    // the width of the timeline component between the two buttons (prev and next)
    var maxPosition = Math.min(props.visibleWidth - props.totalWidth, 0); // NEVER scroll to the right

    _this3.setState({
      position: Math.max(Math.min(0, position), maxPosition),
      maxPosition: maxPosition
    });
  };

  this.updateSlide = function (direction) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this3.props;

    //  translate the timeline to the left('next')/right('prev')
    if (direction === _Constants2.default.RIGHT) {
      _this3.slideToPosition(_this3.state.position - props.visibleWidth + props.labelWidth, props);
    } else if (direction === _Constants2.default.LEFT) {
      _this3.slideToPosition(_this3.state.position + props.visibleWidth - props.labelWidth, props);
    }
  };

  this.centerEvent = function (index) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this3.props;

    var event = props.events[index];

    _this3.slideToPosition(-event.distance);
  };
};

EventsBar.propTypes = {
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    distance: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.string.isRequired,
    date: _propTypes2.default.string.isRequired
  })).isRequired,
  isTouchEnabled: _propTypes2.default.bool.isRequired,
  totalWidth: _propTypes2.default.number.isRequired,
  visibleWidth: _propTypes2.default.number.isRequired,
  index: _propTypes2.default.number,
  styles: _propTypes2.default.object.isRequired,
  indexClick: _propTypes2.default.func.isRequired,
  labelWidth: _propTypes2.default.number.isRequired,
  fillingMotion: _propTypes2.default.object.isRequired,
  barPaddingRight: _propTypes2.default.number.isRequired,
  barPaddingLeft: _propTypes2.default.number.isRequired
};

exports.default = EventsBar;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/Components/EventsBar.js
// module id = 1147
// module chunks = 0